import { TextField } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { Controller, useFormContext } from 'react-hook-form';

type ControlledFormDateTimePickerProps = {
  name: string;
  label: string;
  required?: boolean;
};

export const ControlledFormDateTimePicker = (props: ControlledFormDateTimePickerProps) => {
  const { name, label, required = false } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <DateTimePicker
            {...field}
            value={field.value ? dayjs(field.value) : null}
            format='YYYY-MM-DD HH:mm'
            ampm={false}
            label={label}
            displayWeekNumber
            slotProps={{
              textField: {
                size: 'small',
                fullWidth: true,
                required,
                error: !!error,
                helperText: error?.message,
                InputLabelProps: { shrink: true },
              },
            }}
            slots={{
              textField: TextField,
            }}
          />
        );
      }}
    />
  );
};
